export const lessonsSelector = (state: any) => state.lessons;
